import React, { Component } from 'react';
import { Alert, Button, Col, Form, Input, InputNumber, Modal, Popconfirm, Row, Select, Space, Table } from "antd";
import utils from "../common/utils";
import { FaPencilAlt } from "react-icons/fa";
import { AiOutlineCloseCircle, AiOutlinePlusCircle, AiOutlineEdit, AiFillSave } from 'react-icons/ai'
import _ from 'lodash'
import DisplayControl from './DisplayControl';
import consts from '../consts';

const PAGE_PUBLIC_KEY_SIZE = 10
const layout = {
    labelCol: {
        span: 4,
    },
    wrapperCol: {
        span: 20,
    },
};

const tailLayout = {
    wrapperCol: {
        offset: 16,
        span: 8,
    },
};
const { Option } = Select;

class ShowCryptoSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            publicKeys: [],
            totalPublicKeys: 0,
            visible: false,
            editing: false,
            configCurr: 'enable_app_version_android',
            cryptoSettings: {
                "enable_all": false,
                "enable_app_version_android": [],
                "enable_app_version_ios": [],
                "enable_os_version_android": [],
                "enable_os_version_ios": []
            },
        };
    }

    changeEnableAll = () => {
        let { cryptoSettings } = this.state;
        cryptoSettings.enable_all = !cryptoSettings.enable_all;
        this.setState({
            cryptoSettings,
        })
    }

    handleReceiveData = () => {
        this.props.onFetchCryptoExchangeConfigAction();
        this.props.onFetchListPublicKeyActiveListCryptoAction({ pos: 0, count: PAGE_PUBLIC_KEY_SIZE }, (total, data) => {
            this.setState({
                totalPublicKeys: total,
                publicKeys: data == null ? [] : _.concat(this.state.publicKeys, data),
            })
        });
    }

    deleteConfig = (key, value) => {
        let { cryptoSettings } = this.state;
        _.remove(cryptoSettings[key], e => e == value);
        this.setState({ cryptoSettings })
    }

    getColumnsCryptoExchangeSettings = (data) => {
        return [
            {
                align: "center",
                title: "Phiên bản của ứng dụng Android",
                dataIndex: "enable_app_version_android",
                key: "enable_app_version_android",
                width: "25%",
                editable: true,
                render: (_, dataRow) => {
                    return <Popconfirm title="Bạn có muốn xóa không?"
                        onConfirm={() => this.deleteConfig('enable_app_version_android', dataRow['enable_app_version_android'])}>
                        <div>{dataRow['enable_app_version_android']}</div>
                    </Popconfirm>
                },
            },
            {
                align: "center",
                title: "Phiên bản của ứng dụng IOS",
                dataIndex: "enable_app_version_ios",
                key: "enable_app_version_ios",
                width: "25%",
                editable: true,
                render: (_, dataRow) => {
                    return <Popconfirm title="Bạn có muốn xóa không?"
                        onConfirm={() => this.deleteConfig('enable_app_version_ios', dataRow['enable_app_version_ios'])}>
                        <div>{dataRow['enable_app_version_ios']}</div>
                    </Popconfirm>
                },
            },
            {
                align: "center",
                title: "Phiên bản Android",
                dataIndex: "enable_os_version_android",
                key: "enable_os_version_android",
                width: "25%",
                editable: true,
                render: (_, dataRow) => {
                    return <Popconfirm title="Bạn có muốn xóa không?"
                        onConfirm={() => this.deleteConfig('enable_os_version_android', dataRow['enable_os_version_android'])}>
                        <div>{dataRow['enable_os_version_android']}</div>
                    </Popconfirm>
                },
            },
            {
                align: "center",
                title: "Phiên bản IOS",
                dataIndex: "enable_os_version_ios",
                key: "enable_os_version_ios",
                width: "25%",
                editable: true,
                render: (_, dataRow) => {
                    return <Popconfirm title="Bạn có muốn xóa không?"
                        onConfirm={() => this.deleteConfig('enable_os_version_ios', dataRow['enable_os_version_ios'])}>
                        <div>{dataRow['enable_os_version_ios']}</div>
                    </Popconfirm>
                },
            },
        ];
    }

    getColumnsPublicKeySettings = (data) => {
        return [
            {
                align: "center",
                title: "Public key",
                dataIndex: "publicKey",
                key: "publicKey",
                // width: "25%",
            },
            {
                align: "center",
                title: "Xóa",
                dataIndex: "delete",
                key: "delete",
                width: 100,
                render: (_, dataRow) =>
                    <DisplayControl permission_link_screen={consts.AUTH.SETTING__PUBKEYACTIVELISTCRYPTOEXCHANGE} action={consts.CONTROLS.DELETE}>
                        <Popconfirm title="Bạn có muốn xóa không?" onConfirm={() => {
                            this.props.deletePublicKeyActiveListCryptoAction({
                                "pubkey": dataRow.publicKey
                            }, () => {
                                this.props.onFetchListPublicKeyActiveListCryptoAction({
                                    pos: 0,
                                    count: PAGE_PUBLIC_KEY_SIZE
                                }, (total, data) => {
                                    this.setState({
                                        totalPublicKeys: total,
                                        publicKeys: data,
                                    })
                                });
                            })
                        }}>
                            <AiOutlineCloseCircle size={22} color={"red"} style={{ cursor: 'pointer' }} title={"Xóa"} />
                        </Popconfirm>
                    </DisplayControl>
                    ,
            },
        ];
    }

    transformDataCryptoExchangeSettings = (data) => {
        if (data == null || data.length <= 0) return [];
        let {
            enable_app_version_android,
            enable_app_version_ios,
            enable_os_version_android,
            enable_os_version_ios
        } = data
        let maxL = _.max([
            _.get(enable_app_version_android, 'length', 0),
            _.get(enable_app_version_ios, 'length', 0),
            _.get(enable_os_version_android, 'length', 0),
            _.get(enable_os_version_ios, 'length', 0)
        ]);
        let result = []
        for (let i = 0; i < maxL; ++i) {
            result = _.concat(result, {
                enable_app_version_android: _.get(enable_app_version_android, i, ''),
                enable_app_version_ios: _.get(enable_app_version_ios, i, ''),
                enable_os_version_android: _.get(enable_os_version_android, i, ''),
                enable_os_version_ios: _.get(enable_os_version_ios, i, '')
            })
        }
        return result
    }

    getDataPublicKeySettings = () => {
        return _.map(this.state.publicKeys, e => {
            return {
                "publicKey": e,
                "delete": false,
            }
        });
    }

    onChangePagePublicKeyTable = (page, pageSize) => {
        if (this.state.publicKeys.length <= (page - 1) * pageSize)
            this.props.onFetchListPublicKeyActiveListCryptoAction({
                pos: (page - 1) * pageSize,
                count: pageSize,
            }, (total, data) => {
                this.setState({
                    totalPublicKeys: total,
                    publicKeys: _.concat(this.state.publicKeys, data),
                })
            })
    }

    handleCancel = () => {
        this.setState({
            visible: false
        })
    }

    onAddNewPubKey = (values) => {
        this.props.addPublicKeyToActiveListCryptoAction({
            pubkey: values.newPubKey,
        }, () => {
            this.props.onFetchListPublicKeyActiveListCryptoAction({
                pos: 0,
                count: PAGE_PUBLIC_KEY_SIZE
            }, (total, data) => {
                this.setState({
                    totalPublicKeys: total,
                    publicKeys: data,
                })
            });
            utils.showNotification("Thêm public key", "Thành công", 'success')
        });
        this.setState({
            visible: false
        })
    }

    onAddNewConfig = (values) => {
        if (_.isNil(values.configNew)) return;
        let { cryptoSettings } = this.state;
        if (_.isNil(cryptoSettings[this.state.configCurr])) cryptoSettings = {
            "enable_all": false,
            "enable_app_version_android": [],
            "enable_app_version_ios": [],
            "enable_os_version_android": [],
            "enable_os_version_ios": []
        }
        cryptoSettings[this.state.configCurr] = _.concat(cryptoSettings[this.state.configCurr], values.configNew);
        this.setState({ cryptoSettings, editing: false });
    }

    updateConfigCryptoSetting = () => {
        this.props.updateCryptoExchangeConfigAction(
            _.cloneDeep(this.state.cryptoSettings),
            () => {
                this.props.onFetchCryptoExchangeConfigAction();
                utils.showNotification("Cập nhật cấu hình vào sàn", "Thành công", 'success')
            }
        )
    }

    componentDidMount() {
        this.handleReceiveData();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log(nextProps.cryptoSettings);
        this.setState({
            cryptoSettings: nextProps.cryptoSettings,
        })
    }

    render() {
        const { visible, editing, configCurr, cryptoSettings } = this.state;
        return (
            <div className="withdrawalHistory">
                <h3>Cấu hình vào sàn</h3>
                <Row>
                    <Col span={22}>
                        <div style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-end' }}>
                            <span style={{ marginRight: 10 }}>Kích hoạt tất cả</span>
                            <input type={"checkbox"} checked={cryptoSettings.enable_all}
                                onChange={this.changeEnableAll}
                                height={20} />
                        </div>
                    </Col>
                    <Col span={2}>
                        <div style={{
                            display: 'inline-flex',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                            width: '100%',
                            paddingTop: 5
                        }}>
                            <DisplayControl permission_link_screen={consts.AUTH.SETTING__CRYPTOEXCHANGECONFIG} action={consts.CONTROLS.PUT}>
                                <AiFillSave size={25} onClick={this.updateConfigCryptoSetting} style={{ cursor: 'pointer' }} title={"Lưu"} />
                            </DisplayControl>
                            
                            <AiOutlineEdit size={25} onClick={() => this.setState({
                                editing: true,
                            })} style={{ cursor: 'pointer' }} title={"Chỉnh sửa"} />
                        </div>
                    </Col>
                </Row>
                <Table columns={this.getColumnsCryptoExchangeSettings(cryptoSettings)}
                    dataSource={this.transformDataCryptoExchangeSettings(cryptoSettings) || []}
                    bordered>

                </Table>
                <Row>
                    <Col span={18}><h3>Danh sách public key kích hoạt được sàn</h3></Col>
                    <Col span={6}>
                        <div style={{
                            display: 'inline-flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            width: '100%',
                            paddingTop: 5
                        }}>
                            <DisplayControl permission_link_screen={consts.AUTH.SETTING__PUBKEYTOACTIVELISTCRYPTOEXCHANGE} action={consts.CONTROLS.PUT}>
                                <AiOutlinePlusCircle size={25} color={'rgba(0,146,255,.75)'} onClick={() => {
                                    this.setState({
                                        visible: true,
                                    })
                                }} style={{ cursor: 'pointer' }} title={"Thêm pubkey"} />
                            </DisplayControl>
                            
                        </div>
                    </Col>
                </Row>
                <Table columns={this.getColumnsPublicKeySettings(this.props.cryptoSettings)}
                    dataSource={this.getDataPublicKeySettings() || []}
                    pagination={{
                        defaultPageSize: 10,
                        total: this.state.totalPublicKeys,
                        showSizeChanger: false,
                        onChange: this.onChangePagePublicKeyTable
                    }}
                    bordered>

                </Table>
                <Modal title="Thêm public key"
                    visible={visible}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <Form {...layout} onFinish={this.onAddNewPubKey}>
                        <Form.Item label="Pubkey" name="newPubKey"
                            rules={[{ required: true, message: 'Phải nhập pubkey' }]}

                        >
                            <Input type={"text"} name="newPubKey" />
                        </Form.Item>
                        <Form.Item {...tailLayout} style={{ marginBottom: '12px' }}>
                            <Button
                                type="primary"
                                onClick={this.handleCancel}
                                style={{ width: '64px' }}
                            >
                                Hủy
                            </Button>
                            <Button
                                type="primary"
                                htmlType={'submit'}
                                style={{ width: '64px', marginLeft: 10 }}
                            >
                                Thêm
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    title="Thêm cấu hình sàn"
                    visible={editing}
                    footer={null}
                    onCancel={() => this.setState({
                        editing: false,
                    })}
                >
                    <Form onFinish={this.onAddNewConfig}>
                        <Form.Item name="configNew">
                            <span>
                                <Select
                                    value={configCurr}
                                    style={{
                                        width: 200,
                                        margin: '0 8px',
                                    }}
                                    onChange={(value) => {
                                        this.setState({
                                            configCurr: value
                                        })
                                    }}
                                >
                                    <Option value="enable_app_version_android">Phiên bản của ứng dụng Android</Option>
                                    <Option value="enable_app_version_ios">Phiên bản của ứng dụng IOS</Option>
                                    <Option value="enable_os_version_android">Phiên bản Android</Option>
                                    <Option value="enable_os_version_ios">Phiên bản IOS</Option>
                                </Select>
                                <Input type={"text"} name="newPubKey" style={{
                                    width: 200,
                                }} />
                            </span>
                        </Form.Item>
                        <Form.Item {...tailLayout} style={{ marginBottom: '12px' }}>
                            <Button
                                type="primary"
                                onClick={() => this.setState({
                                    editing: false,
                                })}
                                style={{ width: '64px' }}
                            >
                                Hủy
                            </Button>
                            <Button
                                type="primary"
                                htmlType={'submit'}
                                style={{ width: '64px', marginLeft: 10 }}
                            >
                                Thêm
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default ShowCryptoSetting;
